import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChainLink3"><Path d="M9.5 14.5L14.5 9.5M9.28684 5.7513L10.6821 4.35606C13.1568 1.88131 17.1692 1.88131 19.6439 4.35606C22.1187 6.83081 22.1187 10.8432 19.6439 13.3179L18.2487 14.7132M5.7513 9.28684L4.35606 10.6821C1.88131 13.1568 1.88131 17.1692 4.35606 19.6439C6.83081 22.1187 10.8432 22.1187 13.3179 19.6439L14.7132 18.2487" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChainLink3;
